import React from 'react'
import Dashboard from '../dashboard'
import RatesView from './page'

const Rates = () => {
  return <Dashboard component={<RatesView />} />
}

export default Rates
